var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7zm6.42 2.4l.08-.1a.7.7 0 0 1 1.2.5.7.7 0 0 1-.04.27.63.63 0 0 1-.38.37.66.66 0 0 1-.53 0 .63.63 0 0 1-.38-.37.59.59 0 0 1-.06-.27v-.14l.05-.13a.53.53 0 0 1 .06-.12zM7 12.6A5.6 5.6 0 1 1 7 1.4a5.6 5.6 0 0 1 0 11.2zM5.18 4.55A2.1 2.1 0 0 1 7 3.5a2.1 2.1 0 0 1 .7 4.07v.13a.7.7 0 1 1-1.4 0V7c0-.39.31-.7.7-.7a.7.7 0 1 0-.6-1.05.7.7 0 1 1-1.22-.7z","fill":"#D4D4D7"}));
}

Info.defaultProps = {"width":"14","height":"14","fill":"none"};

module.exports = Info;

Info.default = Info;
